import moment from 'moment';
import { Global } from '@/Config';

// Filtro para converter um objeto Date em uma string
// no formato Brasileiro de Data com horário
export default (date, displayDateTimeParam) => {
  let displayDateTime = Global.format.displayDateTime;

  if (!displayDateTime) {
    displayDateTime = displayDateTimeParam;
  }

  if (date) {
    return moment(String(date), Global.format.parseDateTime).format(displayDateTime);
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/filters/PrDateTimeFilter.js